// 导入 axios 请求
import axios from 'axios'
import $router from '@/router/index.js'
import { Loading } from 'element-ui'
import $msg from '@/utils/message.js'
import $store from '@/store/index.js'

// 导入 进度条 Nprogress 包对应的 js 和 css
import Nprogress from 'nprogress'
import 'nprogress/nprogress.css'

// 配置请求根路径
// axios.defaults.baseURL = "http://192.168.0.170:9158"
// axios.defaults.baseURL = 'http://127.0.0.1:9158'
axios.defaults.baseURL = 'https://lcxyclient.shanlin.cc'

var load = null
// 配置请求拦截
axios.interceptors.request.use(req => {
	let whiteList = [
		'/admin/system/getCaptcha',
		'/admin/fwUser/login',
		'/admin/fwModel/modelList',
		'/admin/fwEventAttr/list',
		'/admin/fwModelEvent/getApiFilePower'
	]
	if(!whiteList.includes(req.url)){
		let token = localStorage.getItem("token")
		if(token) req.headers.token = token
		else {
			$store.commit('clearLoginInfo')
			$router.replace('/login')
			return $msg.error('请先登录')
		}
		let nowSchoolId = sessionStorage.getItem("nowSchoolId")
		if(nowSchoolId){
			if(req.method == 'get'){
				if(req.params) req.params.nowSchoolId = nowSchoolId
				else req.params = { nowSchoolId }
			}else if(req.method == 'post'){
				if(req.data) req.data.nowSchoolId = nowSchoolId
				else req.data = { nowSchoolId }
			}
		}
		
	}
	if(req.url == '/admin/common/exportList'){
		req.responseType = "blob"
	}
	// 加载动画
	load = Loading.service({
		lock: true,
		text: 'Loading',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0, 0.7)'
	})
	Nprogress.start()
	return req
})

// 配置响应拦截器
axios.interceptors.response.use(res => {
	load.close()
	Nprogress.done()
	if(res.config.responseType == "blob"){
		let data = res.data
		// 获取headers中的filename文件名
		const tempName = res.headers["content-disposition"]
		.split(";")[1]
		.split("filename=")[1];
		// iconv-lite解决中文乱码
		const iconv = require("iconv-lite");
		iconv.skipDecodeWarning = true; // 忽略警告
		const fileName = iconv.decode(tempName, "gbk");
		const blob = new Blob([data], { type: "application/vnd.ms-excel" }); // 转换成二进制对象
		if ("download" in document.createElement("a")) {
			// 不是IE浏览器
			const url = window.URL.createObjectURL(blob); // 二进制对象转换成url地址
			const link = document.createElement("a");
			link.style.display = "none";
			link.href = url;
			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link); // 下载完成移除元素
			window.URL.revokeObjectURL(url); // 释放掉blob对象
		} else {
			window.navigator.msSaveBlob(blob, fileName);
		}
	}else if(res.data.code != 200){
		if(res.data.code == 420 || res.data.code == 421 ){
			$store.commit('clearLoginInfo')
			$router.replace('/login')
		}
		$msg.error(res.data.message)
		return Promise.reject(res.data.message)
	}
	return res.data.data
}, (error) => {
	load.close()
	Nprogress.done()
	try{
		let errorCode = error.response.status
		if(errorCode == 401 || errorCode == 403){
			$store.commit('clearLoginInfo')
			$router.replace('/login')
		}else{
			$msg.error('服务器繁忙，请稍后重试')
		}
		return Promise.reject(error)
	}catch(e){
		$msg.error('请求异常，请稍后重试')
	}
})


export default axios